import React, { useState } from 'react'
import { Moment } from 'moment'
import { Box } from '@mui/material'
import RepeatIcon from '@mui/icons-material/Repeat'
import { DatePicker } from 'Components/SharedComponents/DatePicker/DatePicker'
import { ClearIcon } from '@mui/x-date-pickers'
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined'
import { colors } from '@resiliatech/birdsong'

type TaskDueDateProps = {
  dueDate: string | null
  onDueDateChange: (newDate: Moment | null) => void
  hasGroupId: boolean
  isParentHovered?: boolean
}

export const TaskDueDate = ({
  dueDate,
  onDueDateChange,
  hasGroupId,
  isParentHovered,
}: TaskDueDateProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const [open, setIsOpen] = useState(false)

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: '200px',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <DatePicker
        date={dueDate}
        label='Due date'
        onDateSelected={onDueDateChange}
        styles={{ width: '100%' }}
        props={{
          open,
          onClose: () => setIsOpen(false),
          slots: {
            openPickerIcon: InsertInvitationOutlinedIcon,
            clearIcon: ClearIcon,
          },
          slotProps: {
            openPickerIcon: {
              sx: { color: colors.interactive.primaryEnabled },
            },
            clearIcon: {
              sx: {
                position: 'absolute',
                right: 40,
                top: '50%',
                transform: 'translateY(-50%)',
              },
            },
            textField: {
              sx: {
                position: 'relative',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '& .MuiInputBase-root': {
                  paddingRight: '64px',
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '.MuiFormLabel-root': {
                  backgroundColor: isParentHovered
                    ? colors.illustration.lightBlue10
                    : 'inherit',
                },
              },
              InputProps: {
                endAdornment: (
                  <Box
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {dueDate && isHovered && (
                      <ClearIcon
                        onClick={() => onDueDateChange(null)}
                        sx={{
                          cursor: 'pointer',
                          marginRight: '4px',
                          color: colors.interactive.disabledLight,
                        }}
                      />
                    )}
                    <InsertInvitationOutlinedIcon
                      onClick={() => setIsOpen(true)}
                      sx={{
                        cursor: 'pointer',
                        color: colors.interactive.primaryEnabled,
                      }}
                    />
                    {hasGroupId && (
                      <RepeatIcon
                        sx={{
                          marginLeft: '4px',
                          color: colors.interactive.primaryEnabled,
                        }}
                      />
                    )}
                  </Box>
                ),
              },
            },
          },
        }}
      />
    </Box>
  )
}
